/**
 * One shared read of the store offerings.
 *
 * The paywall shows packages (what is bought) and trial terms (what is
 * promised). Both must describe the same offering, so every caller in the same
 * window gets the same promise and derives what it needs from that one result.
 * A failed read is dropped at once so a retry fetches again.
 */
export function createSnapshotLoader (load, { ttlMs = 15000, now = () => Date.now() } = {}) {
  let promise = null
  let startedAt = 0

  return function loadSnapshot ({ fresh = false } = {}) {
    if (promise && !fresh && now() - startedAt < ttlMs) return promise
    const request = load()
    promise = request
    startedAt = now()
    request.catch(() => {
      if (promise === request) promise = null
    })
    return request
  }
}
